export default __webpack_public_path__ + "static/media/bgform.f7398032.png";